import React from 'react';

import { Section, Grid, GridCol, TextContainer } from '../../components';

import NewsletterForm from '../NewsletterForm';
import NewsletterInvitation from '../NewsletterInvitation';

const Newsletter = () => (
  <Section space="xlarge" className="border-bottom border-dark-grey">
    <Grid>
      <GridCol
        size={{ m: 18, l: 14 }}
        offset={{ xs: 'center', l: 6 }}
        className="pl-l-none"
      >
        <Grid className="align-items-justify align-items-middle">
          <GridCol size={{ s: 13, m: 14, xl: 11 }}>
            <TextContainer>
              <NewsletterInvitation />
            </TextContainer>
          </GridCol>
          <GridCol size={{ s: 13, m: 12, xl: 10 }}>
            <NewsletterForm />
          </GridCol>
        </Grid>
      </GridCol>
    </Grid>
  </Section>
);

export default Newsletter;



// WEBPACK FOOTER //
// ./src/modules/Newsletter/index.js